import '../../styles/checkout-header.css';
import Link from '@/components/atoms/link';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

const CheckoutHeader = () => {

    return (
        <div className="checkoutheader lg:ml-16">
            <div className='checkoutheader__heading'>
                <h2>
                    Checkout</h2>
                <div className='checkoutheader__breadcrumb capitalize !text-[17px] flex gap-[]'>
                    <Link className='!text-[17px]' chevron={true} link={"/"}>
                        Home
                    </Link>
                    <div className='w-[17px] h-[17px]' >
                        <ChevronRightIcon width={17} fill='#000000' />
                    </div>
                    <Link className='!text-[17px]' chevron={true} link={"/cart"}>
                        Cart
                    </Link>
                      <div className='w-[17px] h-[17px]' >
                        <ChevronRightIcon width={17} fill='#000000' />
                    </div>
                    <Link className='!text-[17px]' link={"/checkout"}>
                        Checkout
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CheckoutHeader;
